import { Language } from "../interface/language.interfac";
import { HeaderItem, SubmenuItem } from "../types/menu.type";

export const headerData: HeaderItem[] = [
  {
    label: "header.community",
    href: "/",
  },
  {
    label: "header.market",
    href: "#",
    submenu: [
      {
        title: "market.sections.marketPrice",
        items: [
          { label: "market.items.goldPrice", href: "/market/gold-price" },
          { label: "market.items.usdInEgypt", href: "/market/usd-in-egypt" },
          { label: "market.items.usdInBlackMarket", href: "/market/black-market-in-egypt" },
        ],
      },
      {
        title: "market.sections.forexChart",
        items: [
          { label: "market.items.mainCurrencies", href: "/market/forex/main-currencies" },
          { label: "market.items.crossCurrencies", href: "/market/forex/cross-currencies" },
          { label: "market.items.index", href: "/market/forex/index-currencies" },
          { label: "market.items.metals", href: "/market/metals" },
        ],
      },
      {
        title: "market.sections.otherTraderChart",
        items: [
          { label: "market.items.crypto", href: "/market/crypto" },
          { label: "market.items.indicators", href: "/market/indicator" },
          { label: "market.items.stock", href: "/market/stock" },
          { label: "market.items.energy", href: "/market/energy" },
        ],
      },
    ],
  },
  {
    label: "header.analytics",
    href: "/#",
    submenu: [
      {
        title: "analytics.sections.analyticsTools",
        items: [
          { label: "analytics.items.latestAnalytics", href: "/analytic/latest-analytics" },
          { label: "analytics.items.forex", href: "/analytic/forex" },
          { label: "analytics.items.crypto", href: "/analytic/crypto" },
          { label: "analytics.items.metals", href: "/analytic/metals" },
        ],
      },
      {
        title: "analytics.sections.otherAnalytics",
        items: [
          { label: "analytics.items.indicators", href: "/analytic/indicators" },
          { label: "analytics.items.energy", href: "/analytic/energy" },
          { label: "analytics.items.assets", href: "/analytic/assets" },
          { label: "analytics.items.shares", href: "/analytic/shares" },
        ],
      },
      {
        title: "analytics.sections.analyticsVideos",
        items: [
          { label: "analytics.items.analyticsVideos", href: "/analytic/weekly-analytics-videos" },
        ],
      },
    ],
  },
  {
    label: "header.news",
    href: "#",
    submenu: [
      {
        title: "news.sections.newsCategories",
        items: [
          { label: "news.items.latestNews", href: "/news/latest-news" },
          { label: "news.items.forex", href: "/news/forex" },
          { label: "news.items.crypto", href: "/news/crypto" },
          { label: "news.items.metals", href: "/news/metals" },
        ],
      },
      {
        title: "news.sections.otherCategories",
        items: [
          { label: "news.items.indicators", href: "/news/indicators" },
          { label: "news.items.energy", href: "/news/energy" },
          { label: "news.items.assets", href: "/news/assets" },
          { label: "news.items.shares", href: "/news/shares" },
        ],
      },
    ],
  },
  {
    label: "header.store",
    href: "/#",
    submenu: [
      {
        title: "store.sections.storeItems",
        items: [
          { label: "store.items.latestProduct", href: "/store/latest-product" },
          { label: "store.items.expert", href: "/store/expert" },
          { label: "store.items.indicator", href: "/store/indicator" },
          { label: "store.items.free", href: "/store/free" },
        ],
      },
      {
        title: "store.sections.academy",
        items: [
          { label: "store.items.courses", href: "/store/academy" },
          { label: "store.items.book", href: "/store/book" },
          { label: "store.items.educationalArticle", href: "/store/opinion-and-articel" },
        ],
      },
      // {
      //   title: "store.sections.generateAdvisor",
      //   items: [
      //     { label: "store.items.makeExpert", href: "/store/make-expert" },
      //     { label: "store.items.makeIndicator", href: "/store/make-indicator" },
      //   ],
      // },
    ],
  },
  {
    label: "header.tradeByAI",
    href: "#",
    badge: true,
    submenu: [
      {
        title: "ai.sections.tradeByAI",
        items: [
          { label: "ai.items.aiCopyTrades", href: "/ai/copy-treader" },
          { label: "ai.items.traderStrategies", href: "/ai/trader-strategies" },
          { label: "ai.items.sendTradesToProfessionals", href: "/ai/send-trades-to-professionals" },
        ],
      },
    ],
  },
  {
    label: "header.tools",
    href: "#",
    submenu: [
      {
        title: "tools.sections.utilities",
        items: [
          { label: "tools.items.economicCalendar", href: "/economic-calendar" },
          { label: "tools.items.educationalArticle", href: "/opinion-and-articel" },
          { label: "tools.items.webinar", href: "/webiner" },
        ],
      },
      {
        title: "tools.sections.signals",
        items: [
          { label: "tools.items.freeSignals", href: "/free-signal" },
          { label: "tools.items.paidSignals", href: "/paid-signal" },
          { label: "tools.items.subscribeSignals", href: "/subscribe-signal" },
          { label: "tools.items.goldSignals", href: "/gold-signal" },
        ],
      },
      {
        title: "tools.sections.calculator",
        items: [
          { label: "tools.items.pipCalculator", href: "/pip-calculator" },
          { label: "tools.items.marginCalculator", href: "/margin-calculator" },
          { label: "tools.items.currencyExchange", href: "/currency-change" },
          { label: "tools.items.profitLoss", href: "/profitloss" },
          { label: "tools.items.positionSize", href: "/positionsize" },
        ],
      },
    ],
  },
  {
    label: "header.brokers",
    href: "#",
    submenu: [
      {
        title: "brokers.sections.brokerTools",
        items: [
          { label: "brokers.items.brokerCFD", href: "/broker" },
          { label: "brokers.items.cryptoBrokers", href: "/broker/crypto" },
          { label: "brokers.items.probTrading", href: "/broker/prob-treading" },
          { label: "brokers.items.cryptoExchange", href: "/broker/exchange" },
        ],
      },
      {
        title: "brokers.sections.brokerPower",
        items: [
          { label: "brokers.items.scamBroker", href: "/broker/scam-brokers" },
          { label: "brokers.items.brokerRating", href: "/broker/rating" },
          { label: "brokers.items.brokerCompare", href: "/broker/comparison" },
        ],
      },
    ],
  },
  {
    label: "header.promotion",
    href: "#",
    submenu: [
      {
        title: "promotion.sections.promotions",
        items: [
          { label: "promotion.items.forexBonus", href: "/promotion/forex-bonus" },
          { label: "promotion.items.forexCashback", href: "/promotion/forex-cashback" },
          { label: "promotion.items.olxPrize", href: "/promotion/olx-prize" },
        ],
      },
      {
        title: "promotion.sections.competitions",
        items: [
          { label: "promotion.items.answerAndWin", href: "/promotion/answer-and-win-competition" },
          { label: "promotion.items.realAccountsCompetition", href: "/promotion/real-accounts-competition" },
          { label: "promotion.items.demoAccountsCompetition", href: "/promotion/demo-accounts-competition" },
        ],
      },
    ],
  },
  {
    label: "header.partnerSocial",
    href: "/partners-social-media",
    badge: true,
  },
  {
    label: "header.vipAccounts",
    href: "/vip-account",
    upgrade: true,
  },
];


export const languages: Language[] = [
  { code: "en", label: "English", flag: "twemoji:flag-united-kingdom" },
  { code: "ar", label: "العربية", flag: "twemoji:flag-saudi-arabia" },
  { code: "my", label: "Malay", flag: "twemoji:flag-malaysia" },
  { code: "zh", label: "简体中文", flag: "twemoji:flag-china" },
  { code: "zh-hant", label: "繁體中文", flag: "twemoji:flag-hong-kong-sar-china" },
  { code: "el", label: "Ελληνικά", flag: "twemoji:flag-greece" },
  { code: "hu", label: "Magyar", flag: "twemoji:flag-hungary" },
  { code: "ru", label: "Русский", flag: "twemoji:flag-russia" },
  { code: "id", label: "Indonesia", flag: "twemoji:flag-indonesia" },
  { code: "ja", label: "日本語", flag: "twemoji:flag-japan" },
  { code: "ko", label: "한국어", flag: "twemoji:flag-south-korea" },
  { code: "es", label: "Español", flag: "twemoji:flag-spain" },
  { code: "vi", label: "Tiếng Việt", flag: "twemoji:flag-vietnam" },
  { code: "th", label: "ไทย", flag: "twemoji:flag-thailand" },
  { code: "hi", label: "हिन्दी", flag: "twemoji:flag-india" },
  { code: "bn", label: "বাংলা", flag: "twemoji:flag-bangladesh" },
  { code: "tr", label: "Türkçe", flag: "twemoji:flag-turkey" },
  { code: "fr", label: "Français", flag: "twemoji:flag-france" },
  { code: "de", label: "Deutsch", flag: "twemoji:flag-germany" },
  { code: "it", label: "Italiano", flag: "twemoji:flag-italy" },
  { code: "pt", label: "Português", flag: "twemoji:flag-portugal" },
  { code: "fa", label: "فارسی", flag: "twemoji:flag-iran" },
];


export const NewsMenu: SubmenuItem[] = [
  { label: "news.items.latestNews", href: "/news/latest-news", show: true },
  { label: "news.items.forex", href: "/news/forex", show: true },
  { label: "news.items.crypto", href: "/news/crypto", show: true },
  { label: "news.items.metals", href: "/news/metals", show: true },
  { label: "news.items.indicators", href: "/news/indicators", show: true },
  { label: "news.items.energy", href: "/news/energy", show: true },
  { label: "news.items.assets", href: "/news/assets", show: true },
  { label: "news.items.shares", href: "/news/shares", show: true },
];

export const analyticMenu: SubmenuItem[] = [
  { label: "analytics.items.latestAnalytics", href: "/analytic/latest-analytics", show: true },
  { label: "analytics.items.forex", href: "/analytic/forex", show: true },
  { label: "analytics.items.crypto", href: "/analytic/crypto", show: true },
  { label: "analytics.items.metals", href: "/analytic/metals", show: true },
  { label: "analytics.items.indicators", href: "/analytic/indicators", show: true },
  { label: "analytics.items.energy", href: "/analytic/energy", show: true },
  { label: "analytics.items.assets", href: "/analytic/assets", show: true },
  { label: "analytics.items.shares", href: "/analytic/shares", show: true },
  { label: "analytics.items.analyticsVideos", href: "/analytic/weekly-analytics-videos", show: true },
];

export const MarketMenu: SubmenuItem[] = [
  { label: "market.items.goldPrice", href: "/market/gold-price", show: true },
  { label: "market.items.usdInEgypt", href: "/market/usd-in-egypt", show: true },
  { label: "market.items.usdInBlackMarket", href: "/market/black-market-in-egypt", show: true },
  { label: "market.items.mainCurrencies", href: "/market/forex/main-currencies", show: true },
  { label: "market.items.crossCurrencies", href: "/market/forex/cross-currencies", show: true },
  { label: "market.items.index", href: "/market/forex/index-currencies", show: true },
  { label: "market.items.metals", href: "/market/metals", show: true },
  { label: "market.items.crypto", href: "/market/crypto", show: true },
  { label: "market.items.indicators", href: "/market/indicator", show: true },
  { label: "market.items.stock", href: "/market/stock", show: true },
  { label: "market.items.energy", href: "/market/energy", show: true },
];

export const BToB: SubmenuItem[] = [
  { label: "bToB.items.marketplace", href: "/p2p", show: true },
  { label: "bToB.items.myOrders", href: "/p2p/orders", show: true },
  { label: "bToB.items.messages", href: "/p2p/chat", show: true },
  { label: "bToB.items.wallet", href: "/p2p/wallet", show: true },
  { label: "bToB.items.disputes", href: "/p2p/disputes", show: true },
  { label: "bToB.items.profile", href: "/p2p/profile", show: true },
];

export const AIMenu: SubmenuItem[] = [
  { label: "ai.items.aiCopyTrades", href: "/ai/copy-treader", show: true },
  { label: "ai.items.traderStrategies", href: "/ai/trader-strategies", show: true },
  { label: "ai.items.sendTradesToProfessionals", href: "/ai/send-trades-to-professionals", show: true },
];

export const ToolsMenu: SubmenuItem[] = [
  { label: "tools.items.economicCalendar", href: "/economic-calendar", show: true },
  { label: "tools.items.educationalArticle", href: "/opinion-and-articel", show: false },
  { label: "tools.items.webinar", href: "/webiner", show: true },

  { label: "tools.items.freeSignals", href: "/free-signal", show: true },
  { label: "tools.items.paidSignals", href: "/paid-signal", show: true },
  { label: "tools.items.subscribeSignals", href: "/subscribe-signal", show: true },
  { label: "tools.items.goldSignals", href: "/gold-signal", show: true },

  { label: "tools.items.pipCalculator", href: "/pip-calculator", show: true },
  { label: "tools.items.marginCalculator", href: "/margin-calculator", show: true },
  { label: "tools.items.currencyExchange", href: "/currency-change", show: true },
  { label: "tools.items.profitLoss", href: "/profitloss", show: true },
  { label: "tools.items.positionSize", href: "/positionsize", show: true },
];

export const BrokerMenu: SubmenuItem[] = [
  { label: "brokers.items.brokerCFD", href: "/broker", show: true },
  { label: "brokers.items.cryptoBrokers", href: "/broker/crypto", show: true },
  { label: "brokers.items.cryptoExchange", href: "/broker/exchange", show: true },
  { label: "brokers.items.probTrading", href: "/broker/prob-treading", show: true },
  { label: "brokers.items.scamBroker", href: "/broker/scam-brokers", show: true },
  { label: "brokers.items.brokerRating", href: "/broker/rating", show: true },
  { label: "brokers.items.brokerCompare", href: "/broker/comparison", show: true },
];

export const PromotionMenu: SubmenuItem[] = [
  { label: "promotion.items.forexBonus", href: "/promotion/forex-bonus", show: true },
  { label: "promotion.items.forexCashback", href: "/promotion/forex-cashback", show: true },
  { label: "promotion.items.olxPrize", href: "/promotion/olx-prize", show: true },
  { label: "promotion.items.answerAndWin", href: "/promotion/answer-and-win-competition", show: true },
  { label: "promotion.items.realAccountsCompetition", href: "/promotion/real-accounts-competition", show: true },
  { label: "promotion.items.demoAccountsCompetition", href: "/promotion/demo-accounts-competition", show: true },
];

export const StoreMenu: SubmenuItem[] = [
  { label: "store.items.latestProduct", href: "/store/latest-product", show: true },
  { label: "store.items.expert", href: "/store/expert", show: true },
  { label: "store.items.indicator", href: "/store/indicator", show: true },
  { label: "store.items.free", href: "/store/free", show: true },
  { label: "store.items.courses", href: "/store/academy", show: true },
  { label: "store.items.book", href: "/store/book", show: true },
  { label: "store.items.educationalArticle", href: "/store/opinion-and-articel", show: true },
];